import {css} from '@emotion/css';
import {IconRotation, IconSize} from './types';

const getIconSize = (size: IconSize): string => {
  switch (size) {
    case IconSize.EXTRA_SMALL:
      return css`
        width: 1.4rem;
        height: 1.4rem;
      `;
    case IconSize.SMALL:
      return css`
        width: 1.8rem;
        height: 1.8rem;
      `;
    case IconSize.MEDIUM:
      return css`
        width: 2.4rem;
        height: 2.4rem;
      `;
    case IconSize.LARGE:
      return css`
        width: 3.6rem;
        height: 3.6rem;
      `;
    case IconSize.EXTRA_LARGE:
      return css`
        width: 4.8rem;
        height: 4.8rem;
      `;
    default:
      return '';
  }
};

const styles = {
  icon: (size: IconSize, rotation: IconRotation): string => css`
    label: icon;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(${rotation}deg);
    ${getIconSize(size)};
  `,
};

export default styles;
